import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Mail, Phone } from "lucide-react";

const linkGroups = [
  {
    title: "Shop",
    links: [
      { to: "/products", label: "All Products" },
      { to: "/sustainable-products", label: "Sustainable Products" },
      { to: "/sustainable-alternatives", label: "Sustainable Alternatives" },
      { to: "/categories", label: "Categories" },
      { to: "/leaderboard", label: "Leaderboard" },
    ],
  },
  {
    title: "Learn",
    links: [
      { to: "/sustainability-score", label: "Sustainability Score" },
      { to: "/methodology", label: "Methodology" },
      { to: "/ai-sustainability", label: "AI Sustainability" },
      { to: "/greenwashing", label: "Greenwashing Checker" },
      { to: "/blog", label: "Blog" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About Us" },
      { to: "/sustainable-shopping-rewards", label: "Rewards & Cashback" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
    ],
  },
];

const Footer = () => (
  <footer className="mt-24 border-t border-border bg-secondary/30" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
      <div className="col-span-2">
        <Link to="/" className="flex items-center gap-2">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-primary text-primary-foreground">
            <Leaf className="h-5 w-5" />
          </span>
          <span className="font-bold text-lg tracking-tight">Ecowallet</span>
        </Link>
        <p className="mt-4 max-w-sm text-sm text-muted-foreground leading-relaxed">
          AI-powered sustainable shopping platform. Ecowallet analyses publicly available product information to
          generate transparent Sustainability Scores and rewards you for every eco-friendly purchase with cashback
          and GreenCoins.
        </p>
        <div className="mt-5 space-y-2">
          <a href="tel:+918319918203" className="flex items-center gap-2 text-sm text-foreground/80 hover:text-primary" data-testid="footer-contact-phone">
            <Phone className="h-4 w-4" /> +91 83199 18203
          </a>
          <a href="mailto:appecowallet@gmail.com" className="flex items-center gap-2 text-sm text-foreground/80 hover:text-primary" data-testid="footer-contact-email">
            <Mail className="h-4 w-4" /> appecowallet@gmail.com
          </a>
        </div>
      </div>

      {linkGroups.map((g) => (
        <div key={g.title}>
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">{g.title}</div>
          <ul className="mt-4 space-y-2.5">
            {g.links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-foreground/80 hover:text-primary transition-colors inline-block py-1"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Ecowallet Technologies. All rights reserved.</span>
        <div className="flex items-center gap-5">
          <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground">Terms</Link>
          <Link to="/methodology" className="hover:text-foreground">Methodology</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
